import clsx from "classnames";
import { SiteFooterCopyright, SiteFooterDetails, SiteFooterNav, SiteFooterSocials, SiteFooterBy, SiteFooterTop} from "./__components";
import SiteFooterLinks from "./__components/SiteFooterLinks";
import classes from "./styles.module.scss";
import PropTypes from "prop-types";
import { getGlobal } from "@/functions/getGlobal";
import Image from "../Image";

export default function SiteFooter({ className = "" }) {
  const global = getGlobal();
  const company_name = global["_theme.company.name"];
  const footer_bg = global["_theme.footer.bg"];

  return (
    <div className={classes.footer}>
      <Image img="/patterns/wormhole-line-new.webp" size="1440x560" alt="footer pattern" className={classes.pattern} />
      <div className={classes.container}>
        <SiteFooterTop />
        <SiteFooterDetails />
        <div className={classes.footer_bottom}>
          <SiteFooterCopyright className={clsx(classes.footer__copyright, "text-white")} />
          <SiteFooterLinks />
          <SiteFooterBy className={clsx(classes.footer__by, "text-white small")} />
        </div>
      </div>
    </div>
  );
}

SiteFooter.propTypes = {
  className: PropTypes.string,
};

// Please can we change the colours on our bottom navigation bar
// so that the main colour is our light grey (hex: #e7e9ea)
// and the vortex and written content are all dark grey (hex: #5b6770)